module.exports = __webpack_public_path__ + "img/8.e4e10f36.webp";